<template>
  <PagesTicketsComponent
    :pageData="data"
  />
</template>

<script setup>
useHead(({
  htmlAttrs: { 'data-page': 'visit' },
}))

const { data, error } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest',
    { query: { path: queryTicketPage() } }
  )
})

if (!data?.value?.data?.id || error?.value) {
  throw createError({ statusCode: 404 })
}

pageSetHead(data)
</script>
